// Loghi istituzionali / riconoscimenti — sorgente UNICA condivisa tra il footer
// pubblico e la pagina "Il Progetto". Immagini ottimizzate in /public/istituzionali.
export const ISTITUZIONALI = [
  { slug: 'parco-nazionale-sila', name: 'Parco Nazionale della Sila', href: 'https://www.parcosila.it' },
  { slug: 'unesco-mab-biosphere', name: 'UNESCO MAB — Riserva della Biosfera', href: 'https://www.unesco.org/en/mab' },
  { slug: 'riserva-biosfera-sila', name: 'Riserva della Biosfera Sila', href: 'https://www.parcosila.it' },
  { slug: 'europarc-cets', name: 'EUROPARC — Carta Europea del Turismo Sostenibile', href: 'https://www.europarc.org/sustainable-tourism/' },
];
